import * as apiMethods from '../../consts/api/apiMethods';
import {DATA_COLLECTORS} from '../../consts/app/requestParamTypes';
import {updateBuildingProfile} from '../../state/ducks/buildings';
import {setCurrentDataCollector, setDataCollectors} from '../../state/ducks/dataCollectors';
import {makeSelectRequestParams} from '../../state/selectors/requestParams';
import {getState} from '../../state/store';
import helpers from '../../utils/helpers';
import ApiClient from '../api/clients/apiClient';
import log from '../logger/log';
import {
    createDataCollectorRequestMapping,
    currentDataCollectorMapping,
    dataCollectorListMapping,
    editDataCollectorRequestMapping,
} from '../mappings/dataCollectorMappings';

const getDataCollectorsList = async (requestParams = makeSelectRequestParams(DATA_COLLECTORS)(getState())) => {
    try {
        const response = await new ApiClient().callPost({
            methodName: apiMethods.DATA_COLLECTORS_LIST,
            requestConfig: {
                data: requestParams,
            },
            action: setDataCollectors,
            mapper: dataCollectorListMapping,
        });

        return response;
    } catch (e) {
        log.error(`getDataCollectorsList: ${e}`);
    }
};

const createDataCollector = async ({formData, onRequestError, onRequestSuccess}) => {
    try {
        await new ApiClient().callPost({
            methodName: apiMethods.DATA_COLLECTORS,
            requestConfig: {
                data: createDataCollectorRequestMapping(formData),
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`createDataCollector: ${e}`);
        helpers.runFunction(onRequestError);
    }
};

const editDataCollector = async ({formData, onRequestSuccess, onRequestError}) => {
    try {
        await new ApiClient().callPut({
            methodName: apiMethods.DATA_COLLECTORS,
            requestConfig: {
                data: editDataCollectorRequestMapping(formData),
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`editDataCollector: ${e}`);
        helpers.runFunction(onRequestError);
    }
};

const unlockDataCollector = async (ids, onRequestSuccess) => {
    try {
        return await new ApiClient().callPost({
            methodName: apiMethods.DATA_COLLECTORS_UNBLOCK,
            requestConfig: {
                data: {uspdIDs: Array.isArray(ids) ? ids : [ids]},
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`unlockDataCollector: ${e}`);
    }
};

const lockDataCollector = async (ids, onRequestSuccess) => {
    try {
        return await new ApiClient().callPost({
            methodName: apiMethods.DATA_COLLECTORS_BLOCK,
            requestConfig: {
                data: {uspdIDs: Array.isArray(ids) ? ids : [ids]},
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`lockDataCollector: ${e}`);
    }
};

const switchBlockDataCollector = async (dataCollectorId, onRequestSuccess) => {
    try {
        return await new ApiClient().callPut({
            methodName: apiMethods.DATA_COLLECTORS_SWITCH_BLOCK,
            requestConfig: {
                data: {uspdID: dataCollectorId},
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`switchBlockDataCollector: ${e}`);
    }
};

const deleteDataCollector = async (dataCollectorId, onRequestSuccess) => {
    try {
        await new ApiClient().callDelete({
            methodName: apiMethods.DATA_COLLECTORS,
            requestConfig: {
                data: {UspdID: dataCollectorId},
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`deleteDataCollector: ${e}`);
    }
};

const getDataCollectorById = async (dataCollectorId, onRequestSuccess) => {
    try {
        await new ApiClient().callGet({
            methodName: apiMethods.DATA_COLLECTOR_BY_ID,
            action: setCurrentDataCollector,
            mapper: currentDataCollectorMapping,
            requestConfig: {
                args: dataCollectorId,
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`getDataCollectorById: ${e}`);
    }
};

const getDataCollectorsByBuildingId = async (buildingId, onRequestSuccess) => {
    try {
        return await new ApiClient().callPost({
            methodName: apiMethods.DATA_COLLECTORS_BY_BUILDING_ID,
            action: updateBuildingProfile,
            requestConfig: {
                args: buildingId,
                data: {
                    page: 1,
                    query: '',
                    sortBy: 'UpdateTs',
                    direction: 1,
                    filters: {},
                },
            },
            onResponse: onRequestSuccess,
        });
    } catch (e) {
        log.error(`getDataCollectorsByBuildingId: ${e}`);
    }
};

export default {
    getDataCollectorById,
    getDataCollectorsList,
    getDataCollectorsByBuildingId,
    createDataCollector,
    editDataCollector,
    unlockDataCollector,
    lockDataCollector,
    switchBlockDataCollector,
    deleteDataCollector,
};
